import React, { Suspense, useEffect, useState } from "react";
import PageHeader from "../../components/layout/pageHeader";
import { useParams, Navigate } from "react-router-dom";
import SubNav from "../../components/header/subnav";
import { getSession } from "../../services/auth";
import { isAdmin } from "../../utilities/permissions";

function Settings() {
	useEffect(() => {
		document.title = "Settings";
		verifyAccess();
	}, []);

	const params = useParams();
	// The heading is derived from the route and capitalised by `.caps`, which turns
	// "arctag-config" into "Arctag Config" while the nav beside it reads "ArcTag
	// Config". Only names the CSS cannot get right belong here; everything absent
	// keeps the derived title, so no existing tab's heading moves.
	const TITLE_OVERRIDES = {
		"arctag-config": "ArcTag Config",
	};
	const id = params.id ?? false
		? TITLE_OVERRIDES[params.id] || params.id.split("-").join(" ")
		: null;

	const lazyRetry = function(componentImport) {
		return new Promise((resolve, reject) => {
			const hasRefreshed = JSON.parse(
				window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
			);
			componentImport().then((component) => {
				window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
				resolve(component);
			}).catch((error) => {
				if (!hasRefreshed) {
					window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
					return window.location.reload();
				}
				reject(error);
			});
		});
	};

	const Content = React.lazy(() => lazyRetry(() => import(`./${params.id}`)));

	const [menu, setMenu] = useState(null);
	const [firstActive, setFirstActive] = useState(null);

	const verifyAccess = async () => {
		const session = getSession();
		if (!session) return;
		
		setMenu([
			{ text: "Publishers", to: "/settings/publishers", disabled: false, hidden: !isAdmin(session.role_id) },
			{ text: "Users", to: "/settings/users", disabled: false, hidden: session.role_id != 1 && session.role_id != 2 },
			{ text: "Tags", to: "/settings/tags", disabled: false, hidden: !isAdmin(session.role_id) },
			{ text: "Integrations", to: "/settings/integrations", disabled: false, hidden: session.role_id != 1 && session.role_id != 2 },
			{ text: "Builder", to: "/settings/builder", disabled: false, hidden: !isAdmin(session.role_id) },
			{ text: "Domain Exclusions", to: "/settings/domains-excluded", disabled: false, hidden: !isAdmin(session.role_id) },
			{ text: "Domain Hints", to: "/settings/domain-hints", disabled: false, hidden: !isAdmin(session.role_id) },
			{ text: "ArcTag Config", to: "/settings/arctag-config", disabled: false, hidden: !isAdmin(session.role_id) },
		]);
	};

	useEffect(() => {
		if (menu) {
			setFirstActive(menu.find((el) => el.disabled == false && el.hidden == false));
		}
	}, [menu]);

	return (
		<div className="wrapper">
			<SubNav list={menu} />
			<PageHeader
				title={<>Settings: {id}</>}
				titleClassName={TITLE_OVERRIDES[params.id] ? "" : "caps"}
				tabsSpacing
			/>
			<Suspense>{id ? <Content /> : <Navigate to={firstActive ? firstActive.to : null} />}</Suspense>
		</div>
	);
}

export default Settings;
